export const usePhone = () => {
  function formatPhoneNumber(phone: string) {
    // Removes all characters that are not numbers
    const cleaned = phone.replace(/\D/g, '')

    // Validated if the number has at least 10 digits (fixed) or 11 (mobile)
    if (cleaned.length === 10) {
      // Format Fixed Phone: (XX) XXXX-XXXX
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
    } else if (cleaned.length === 11) {
      // Formata celular: (XX) 9XXXX-XXXX
      return cleaned.replace(/(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2 $3-$4')
    } else {
      // Returns the original value if not valid
      return phone
    }
  }

  return {
    formatPhoneNumber,
  }
}
